var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupe322(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.636,
    height: 20.636,
    viewBox: "0 0 20.636 20.636",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-595.007-313.364l-10.5,6.065v.37a2.924,2.924,0,0,1-.554,1.716H-595.4a1.717,1.717,0,0,0,1.716-1.716v-4.765a1.718,1.718,0,0,0-1.322-1.67Zm0,0",
    transform: "translate(614.321 325.85)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-587.815-413.209l-1.771-3.068a1.721,1.721,0,0,0-1.487-.858,1.7,1.7,0,0,0-.494.074l-6.44,11.154v.561l9.635-5.563a1.7,1.7,0,0,0,.727-1,1.7,1.7,0,0,0-.171-1.3Zm0,0",
    transform: "translate(606.815 422.483)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-593.98-480.287a1.7,1.7,0,0,0-.8-1.042l-3.065-1.77a1.717,1.717,0,0,0-.857-.23,1.713,1.713,0,0,0-.736.167,2.933,2.933,0,0,1,.1.754V-470l5.188-8.985a1.7,1.7,0,0,0,.172-1.3Zm0,0",
    transform: "translate(608.148 484.122)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-720.2-494.876h-4.153a1.717,1.717,0,0,0-1.716,1.716v17.205a1.718,1.718,0,0,0,1.716,1.716h4.153a1.717,1.717,0,0,0,1.716-1.716v-17.205a1.717,1.717,0,0,0-1.716-1.716Zm-2.076,18a1.152,1.152,0,0,1-1.151-1.151,1.152,1.152,0,0,1,1.151-1.151,1.152,1.152,0,0,1,1.151,1.151,1.152,1.152,0,0,1-1.151,1.151Zm0,0",
    transform: "translate(726.07 494.876)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe322);
export default __webpack_public_path__ + "static/media/Groupe_322.a6a167635c928e658276713323b221f6.svg";
export { ForwardRef as ReactComponent };